import React from 'react'
import Spinner from './Spinner'
import { renderIf } from '../infrastructure/utils'
import './Box.css'

const Box = ({ title, children, loading, tools }) => (
    <div className="ibox float-e-margins">
        {renderIf(title)(
            <div className="ibox-title">
                <h5>{title}</h5>
                {renderIf(tools)(<div className="ibox-tools">{tools}</div>)}
            </div>,
        )}
        <div className={`ibox-content ${loading ? 'sk-loading' : ''}`}>
            {renderIf(loading)(<Spinner />)}
            {renderIf(!loading)(children)}
        </div>
    </div>
)

export default Box
